import { getOrAssignAccountManager } from "@yardzen/rest-api-client";
import useSWR from "swr";

export const useAccountManager = (buildProjectId: string, userId: string) => {
  const { data, error, isLoading } = useSWR(
    buildProjectId && userId
      ? `/build-projects/${buildProjectId}/account-manager/get-or-assign`
      : null,
    buildProjectId && userId
      ? () => getOrAssignAccountManager(buildProjectId, userId)
      : null,
  );

  return {
    accountManager: data?.data,
    isLoading,
    isError: error,
  };
};
